import modal from '@/utils/modal';
import Form from './Form';

export default function openCommentFormV2 (commentType, targetId, parentCommentId = null, skipGuestUsp = false, options) {
    const m = modal.create(Form, {
        stackModals: false,
    });
    m.app.init(
        commentType,
        targetId,
        {
            onCommentCreated: m.destroy,
        },
        parentCommentId,
        skipGuestUsp,
        options,
    );
    return m;
}